export let ButtonStatus;

(function (ButtonStatus) {
  ButtonStatus["IS_SELLABLE"] = "is_sellable";
  ButtonStatus["IS_STOP_SELLABLE"] = "is_stop_sellable";
  ButtonStatus["IS_AVAILABLE"] = "is_available";
  ButtonStatus["FREE_ITEM"] = "free_item";
})(ButtonStatus || (ButtonStatus = {}));

export let ButtonGroupStatus;

(function (ButtonGroupStatus) {
  ButtonGroupStatus["INVENTORY"] = "INVENTORY";
  ButtonGroupStatus["SALE"] = "SALE";
  ButtonGroupStatus["GUEST"] = "GUEST";
})(ButtonGroupStatus || (ButtonGroupStatus = {}));

export let SaleButtonStatus;

(function (SaleButtonStatus) {
  SaleButtonStatus["IS_AVAILABLE"] = "IS_AVAILABLE";
})(SaleButtonStatus || (SaleButtonStatus = {}));

export let InventoryButtonStatus;

(function (InventoryButtonStatus) {
  InventoryButtonStatus["IS_AVAILABLE"] = "IS_AVAILABLE";
  InventoryButtonStatus["IS_SELLING"] = "IS_SELLING";
  InventoryButtonStatus["IS_NOT_MINT"] = "IS_NOT_MINT";
})(InventoryButtonStatus || (InventoryButtonStatus = {}));

export let GuestButtonStatus;

(function (GuestButtonStatus) {
  GuestButtonStatus["IS_NOT_AVAILABLE"] = "IS_NOT_AVAILABLE";
})(GuestButtonStatus || (GuestButtonStatus = {}));